import React from "react";

import { Link } from "react-router-dom";
import { Tag } from "antd";
import { LAYOUT_ADMIN_PRIORITY_EDIT } from "../../navigation";
import { basicDeleteActionField } from "../../../../components/table/fields/common";
import { configureField } from "../../../../core/utils/list";

export const basicColumns = (props) => {
  const { loading, filters, resize, hidden } = props;

  if (loading) return [];

  return [
    {
      title: "Name",
      dataIndex: "name",
      ...configureField(
        "p.name",
        filters,
        resize,
        hidden,
        true,
        false,
        false,
        400
      ),
      render: (name, record) => (
        <Link to={LAYOUT_ADMIN_PRIORITY_EDIT(record.id)}>{name}</Link>
      ),
    },
    {
      title: "Description",
      dataIndex: "description",
      ...configureField(
        "p.description",
        filters,
        resize,
        hidden,
        false,
        false,
        true,
        200
      ),
    },
    {
      title: "Status",
      dataIndex: "active",
      width: 200,
      ...configureField(
        "p.active",
        filters,
        resize,
        hidden,
        true,
        true,
        false,
        200
      ),
      render: (check) => (
        <>
          {check ? (
            <Tag color="green"> ENABLED </Tag>
          ) : (
            <Tag color="volcano"> DISABLED </Tag>
          )}
        </>
      ),
    },
    {
      ...basicDeleteActionField({
        toggle: props.toggle,
        remove: props.remove,
        loading: props.actionLoading,
      }),
      visible: true,
      width: 200,
    },
  ];
};
